import { GenericService } from './../generic.service';
import { Injectable, Injector } from '@angular/core';
import { MessageTemplate } from '../../models/enums/enums';
import { TaskAssignedNotificationService } from './task-assigned-notification.service';
import { TaskCompletedNotificationService } from './task-completed-notification.service';
import { MentorReviewNotificationService } from './mentor-review-notification.service';
import { MeetingScheduledNotificationService } from './meeting-scheduled-notification.service';
import { MeetingCanceledNotificationService } from './meeting-canceled-notification.service';
import { MeetingRescheduledNotificationService } from './meeting-rescheduled-notification.service';
import { EssaySubmissionNotificationService } from './essay-submission-notification.service';
import { DocumentRequestedNotificationService } from './document-requested-notification.service';
import { DocumentUploadedNotificationService } from './document-uploaded-notification.service';
import { NotificationsRequest } from '../../models/notification/notificationRequest';
import { Observable } from 'rxjs';
import { apiResponse } from '../../models/apiResponse';
import { NotificationsResponse } from '../../models/notification/notificationResponse';

export interface INotification {
  notify(message:string,data: { [key: string]: any }): void;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationFactoryService {

  constructor(private injector: Injector,private genericService:GenericService) { }

  getNotificationService(type: MessageTemplate): INotification {
    switch (type) {
      case MessageTemplate.TaskAssigned:
        return this.injector.get(TaskAssignedNotificationService);
      case MessageTemplate.TaskCompleted:
        return this.injector.get(TaskCompletedNotificationService);
      case MessageTemplate.EssaySubmission:
        return this.injector.get(EssaySubmissionNotificationService);
      case MessageTemplate.MentorReview:
        return this.injector.get(MentorReviewNotificationService);
      case MessageTemplate.MeetingScheduled:
        return this.injector.get(MeetingScheduledNotificationService);
      case MessageTemplate.MeetingCanceled:
        return this.injector.get(MeetingCanceledNotificationService);
      case MessageTemplate.MeetingRescheduled:
        return this.injector.get(MeetingRescheduledNotificationService);
      case MessageTemplate.DocumentRequested:
        return this.injector.get(DocumentRequestedNotificationService);
      case MessageTemplate.DocumentUploaded:
        return this.injector.get(DocumentUploadedNotificationService);
      default:
        throw new Error('Invalid notification type');
    }
  }

  getNotiifications(notificationRequest:NotificationsRequest):Observable<apiResponse<NotificationsResponse[]>>{
    return this.genericService.post('notification',notificationRequest);
  }

  getUnreadNotificationCount():Observable<number>{
    return this.genericService.get('notification/count');
  }

  markAllAsRead():Observable<apiResponse<string>>{
    return this.genericService.patch('notification/mark-all-as-read',{});
  }
}
